import { createContext } from 'react';
import { User } from '../../types/auth';

export type NotificationType = 'Todas' | 'PorViaje' | 'PorServicio' | 'Ninguna';

export type UserDataDecodedProps = {
  username: string;
  name: string;
  email: string;
  phone: string;
  armadores: string;
  facwebcc: string;
  cliente_hub_frio: string;
  estado_cuenta_titular: string;
  agente_retencion: string;
  cambioseta: NotificationType;
  armadoresDashboard: string;
  ftpVERMAS?: string;
  ultimo_rut_cliente_liquidacion_electronica_vacio_import?: string;
};
export type AuthContextProps = {
  onLogin: (userData: User) => void;
  onLogout: () => void;
  userDataDecoded: UserDataDecodedProps;
};

export const AuthContext = createContext<AuthContextProps>({
  onLogin: () => {},
  onLogout: () => {},
  userDataDecoded: {
    username: '',
    name: '',
    email: '',
    phone: '',
    armadores: '',
    facwebcc: '',
    cliente_hub_frio: '',
    estado_cuenta_titular: '',
    agente_retencion: '',
    cambioseta: 'Ninguna',
    armadoresDashboard: '',
    ftpVERMAS: undefined,
    ultimo_rut_cliente_liquidacion_electronica_vacio_import: undefined,
  },
});
